($ => {

    $(function() {
        const telCelMasks = ["(99) 9999-9999", "(99) 99999-9999"];
        $(".mask-cpf").on("input", (e) => VMasker(e.target).maskPattern("999.999.999-99"));
        $(".mask-cnpj").on("input", (e) => {
            e.target.value = e.target.value.toUpperCase();
            VMasker(e.target).maskPattern("SS.SSS.SSS/SSSS-SS");
        });
        $(".mask-telcel").on("input", inputTelCelHandler.bind(undefined, telCelMasks, 10));
        $(".mask-telcel").each(function() {
            const input = $(this)[0];
            let maskToApply = telCelMasks[0];
            if (input.value.trim().length == 15) maskToApply = telCelMasks[1];
            VMasker(input).maskPattern(maskToApply);
        });

        $(".mask-money").each(function() {
            const input = $(this)[0];
            VMasker(input).maskMoney();
        });
        $(".mask-money").on("keyup", function(e) {
            if (e.key !== "Backspace" && e.key !== "Delete" && e.keyCode !== 8 && e.keyCode !== 46) return;
            const input = this;
            setTimeout(() => {
                if (Number(input.value.replace(/\D/g, "")) === 0) {
                    input.value = "";
                    input.lastOutput = "";
                }
            }, 0);
        });

        function inputTelCelHandler(masks, max, event) {
            var c = event.target;
            var v = c.value.replace(/\D/g, '');
            var m = v.length > max ? 1 : 0;
            VMasker(c).unMask();
            VMasker(c).maskPattern(masks[m]);
            c.value = VMasker.toPattern(v, masks[m]);
        }
    });

})(jQuery);
